<span [tooltip]="'Agregar filtros al listado' | t" placement="bottom" *ngIf="simpleFilterAvailable">
  <button type="button" class="c-btn-filtro" (click)="openModal($event)">
    Filtros
    <i class="fas fa-filter af af-filter"></i>
  </button>
</span>
